import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import DiscoBall from './disco_ball';
import OptimizedImage from './OptimizedImage';

interface LoadingLogoProps {
    message?: string;
}

const LoadingLogo: React.FC<LoadingLogoProps> = ({ message }) => {
    return (
        <Box sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            background: '#1C1C34',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
        }}>
            <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '240px', height: '240px', mr: 5 }}>
                    <DiscoBall quality='high' size='large' />
                </Box>
                <Box sx={{
                    position: 'absolute',
                    zIndex: 2,
                    transform: 'translateY(10px)',
                    marginLeft: '108px',
                    width: '190px',
                    height: 'auto'
                }}>
                    <OptimizedImage
                        src="https://firebasestorage.googleapis.com/v0/b/rentabar-3d509.appspot.com/o/img%2Flogo_with_light-1.webp?alt=media&token=6f1994ec-34f5-479e-8e02-dd909ecdeee6"
                        alt="Litty Logo"
                        width={190}
                        height={80}
                        priority={true}
                        style={{
                            width: '100%',
                            height: 'auto'
                        }}
                    />
                </Box>
            </Box>
            {message && (
                <Typography
                    variant="h6"
                    color="white"
                    sx={{
                        mt: 2,
                        textAlign: 'center',
                        fontFamily: 'Inter',
                        textShadow: '1px 1px 4px rgba(0, 0, 0, 0.6)'
                    }}
                >
                    {message}
                </Typography>
            )}
        </Box>
    );
};

export default memo(LoadingLogo);
